// src/components/LineList.jsx
import React from "react";
import { Box } from "@mui/material";
import LineRow from "./LineRow";
import { useData } from "../context/DataContext";

export default function LineList() {
  const { lines } = useData();

  return (
    <Box
      sx={{
        width: "100%",
        maxHeight: "280px",
        overflowY: "auto",
        overflowX: "hidden",
        pr: 2.5,
        pl: 1,
        pb: 2,
        boxSizing: "border-box",

        "& > *": {
          width: "100%",
          minWidth: 0,
        },

        // Custom scrollbar (now with safe padding)
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#aaa",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#888",
        },
      }}
    >
      {lines.map((line) => (
        <Box
          key={line.id}
          sx={{
            width: "100%",
            mb: 1.5,
            pr: 0.5,
          }}
        >
          <LineRow lineId={line.id} />
        </Box>
      ))}
    </Box>
  );
}
